import { isPhone, calculateMinWidth } from "@plugins";

const tagsContainers = document.querySelectorAll(".js-tags-limit-width-init");

if (tagsContainers) {
    for (const tagsContainer of tagsContainers) {
        const tagButtonMore = tagsContainer.querySelector(".js-tags-btn-more");

        if (tagButtonMore) {
            initCollapsedTags(tagsContainer, tagButtonMore);
        }
        if (isPhone()) {
            limitTagsWrapperWidth(tagsContainer);
        }
    }
}

function limitTagsWrapperWidth(tagsContainer) {
    const tagsWrap = tagsContainer.querySelector(".js-tags-wrap");

    if (!tagsWrap) {
        const error = "Нет обертки";
        console.error(tagsContainer, error);
    }

    const tags = tagsWrap.children;

    if (!tags) {
        const error = new Error("Нет тегов");
        console.error(tagsWrap, error);
    }

    let minTagsWrapperWidth = 0;
    const elementMarginRight = "8px";

    minTagsWrapperWidth =
        (calculateMinWidth(tags, 0, tags.length, elementMarginRight) / 2) * (1 + 4 / 100);

    tagsWrap.style.minWidth = `${minTagsWrapperWidth}px`;
}

function initCollapsedTags(tagsContainer, tagButtonMore) {
    const tagsWrap = tagsContainer.querySelector(".js-tags-wrap");

    tagButtonMore.addEventListener("click", () => {
        if (tagsWrap.classList.contains("collapsed")) {
            tagsWrap.classList.remove("collapsed");
            tagButtonMore.classList.remove("collapsed");
            tagButtonMore.textContent = "Скрыть";
        } else {
            tagsWrap.classList.add("collapsed");
            tagButtonMore.classList.add("collapsed");
            tagButtonMore.textContent = "Показать ещё";
        }
    });
}
